/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LanguageProficiency } from '../../models/language-proficiency';

export interface GetLanguageProficiency$Params {
  profileId: string;
  id: string;
}

export function getLanguageProficiency(http: HttpClient, rootUrl: string, params: GetLanguageProficiency$Params, context?: HttpContext): Observable<StrictHttpResponse<LanguageProficiency>> {
  const rb = new RequestBuilder(rootUrl, getLanguageProficiency.PATH, 'get');
  if (params) {
    rb.path('profileId', params.profileId, {});
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LanguageProficiency>;
    })
  );
}

getLanguageProficiency.PATH = '/studentprofile/{profileId}/languageproficiency/{id}';
